import { FormErrors } from '@mantine/form';
import { t } from 'i18next';

export const validateRequired = ({
  enabled = true,
  value,
  label,
}: {
  value?: string | number | string[] | Date;
  label?: string;
  enabled?: boolean;
}) => {
  if (!enabled) return null; // Skip validation if not enabled
  if (typeof value === 'number' && value <= 0) return label ? t('validations_required', { value: label }) : '*';
  if (!value?.toString()) return label ? t('validations_required', { value: label }) : '*';
  return null;
};

export const validateLength = (options: { value?: string; label: string; length: number }) => {
  if (!options.value || options.value.length < options.length) return options.label;
  return null;
};

export const validateEmail = (email?: string) => {
  if (!email) return t('validations_required', { value: t('email_label') });
  const regex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line

  if (!regex.test(email)) return t('validations_incorrect_email');

  return null;
};

export const validatePhone = (phoneNumber?: string) => {
  if (!phoneNumber) return t('validations_required', { value: t('phone_label') });
  if (phoneNumber?.length <= 3) return t('validations_incorrect_phoneNumber');

  return null;
};

export const validatePassword = (
  passwordType: 'old' | 'new' | 'confirm',
  value: string,
  values?: {
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
  },
) => {
  if (!value) return t('validations_required', { value: t('password_label') });

  if (passwordType === 'new') {
    if (value === values?.oldPassword) return t('validations_password_must_difer');
  }

  if (passwordType === 'confirm') {
    if (value !== values?.newPassword) return t('validations_password_not_match');
  }

  return null;
};

export const displayFormError = ({
  errors,
  dataField,
  label,
}: {
  errors: FormErrors;
  dataField: string;
  label?: string;
}) => {
  return errors[dataField] ? label || ' ' : null;
};
